import React from 'react'
import styled from '@emotion/styled'

import { ReactComponent as AccordionMinus } from './maxxia-minus.svg'
import { ReactComponent as AccordionPlus } from './maxxia-plus.svg'
import { ReactComponent as ArrowLeft } from './icon-left-arrow.svg'
import { ReactComponent as ArrowRight } from './icon-right-arrow.svg'
import { ReactComponent as BackArrow } from './icon-arrow-back.svg'
import { ReactComponent as BenefitDollar } from './benefit-dollar-icon.svg'
import { ReactComponent as BenefitDollar1 } from './benefit-dollar-icon-1.svg'
import { ReactComponent as BenefitEdit } from './benefit-edit-icon.svg'
import { ReactComponent as BenefitMobile } from './benefit-mobile-icon.svg'
import { ReactComponent as BenefitRepairs } from './benefit-repairs-icon.svg'
import { ReactComponent as BenefitRunningCosts } from './benefit-running-costs-icon.svg'
import { ReactComponent as BenefitTax } from './benefit-tax-icon.svg'
import { ReactComponent as Electricity } from './Icon-electric.svg'
import { ReactComponent as Fuel } from './fuel.svg'
import { ReactComponent as Incidentals } from './incidentals.svg'
import { ReactComponent as Insurance } from './insurance.svg'
import { ReactComponent as LeaseFees } from './lease-fees.svg'
import { ReactComponent as LeasePayout } from './lease-pay-icon.svg'
import { ReactComponent as LeaseRelease } from './lease-release-icon.svg'
import { ReactComponent as LeaseUpgrade } from './lease-upgrade-icon.svg'
import { ReactComponent as Paperclip } from './paperclip-vertical-solid.svg'
import { ReactComponent as Phone } from './phone.svg'
import { ReactComponent as Registration } from './annual-registration.svg'
import { ReactComponent as RoadsideAssistance } from './roadside-assistance.svg'
import { ReactComponent as ScheduledMaintenance } from './servicing.svg'
import { ReactComponent as TrashCan } from './trash.svg'
import { ReactComponent as Tyres } from './tyres.svg'
import { ReactComponent as Umbrella } from './benefit-umbrella-icon.svg'
import { ReactComponent as Upload } from './upload.svg'

const iconsMap = {
  AccordionMinus,
  AccordionPlus,
  ArrowLeft,
  ArrowRight,
  BackArrow,
  BenefitDollar,
  BenefitDollar1,
  BenefitEdit,
  BenefitMobile,
  BenefitRepairs,
  BenefitRunningCosts,
  BenefitTax,
  Electricity,
  Fuel,
  Incidentals,
  Insurance,
  LeaseFees,
  LeasePayout,
  LeaseRelease,
  LeaseUpgrade,
  Paperclip,
  Phone,
  Registration,
  RoadsideAssistance,
  ScheduledMaintenance,
  TrashCan,
  Tyres,
  Umbrella,
  Upload
}

export const Icon = (props) => {
  const iconType = props.iconType
  const size = props.size
  const primary = props.primary
  const CustomIcon = styled(iconsMap[iconType] || null)`
    label: CustomIcon;
    height: ${size ? size * 24 + 'px' : 'auto'};
    fill: ${(props) => primary && props.theme.colors.primary};
  `

  return <CustomIcon {...props} />
}
